import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from "@mui/material/styles";
import ReportAutoEmailScheduler from '../../../Leave/views/TeamTimeEmailScheduler/ReportAutoEmailScheduler';

const ReportScheduler = ({ accordian }) => {
    const theme = useTheme()
    const [expanded, setExpanded] = useState(accordian);
  const { report_schedule_data } = useSelector(state => state?.AncillaryReducer?.ReportSchedulerReducer);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }
    const values = [
        { name: "Report Scheduler", comp: <ReportAutoEmailScheduler />, count: report_schedule_data?.length || 0 },
    ]

    const actionSummaryStyle = {
        minHeight: 50,
        maxHeight: 50,
        borderRadius: "10px 10px 0px 0px",
        // backgroundColor: '#a5a5a5',
        '&.Mui-expanded': {
            minHeight: 50,
            maxHeight: 50,
            backgroundColor: theme?.palette?.primary?.dark,
            color: "white",
        }
    }

    return (
        <div style={{ padding: "10px 0px" }}>
            {values.map((value, id) => {
                return (
                    <Accordion key={id} expanded={expanded === `${value.name}`} onChange={handleChange(`${value.name}`)} sx={{ borderRadius: "10px" }}>
                        <AccordionSummary sx={actionSummaryStyle}
                            expandIcon={<KeyboardArrowDownIcon />}
                            id='controlled-panel-header-1'
                            aria-controls='controlled-panel-content-1'
                        >
                            <Typography sx={{color:theme.palette.primary.contrastText}} variant='body1' fontWeight={600}>{value.name} ({value.count})</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {value.comp}
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </div>
    );
}

export default ReportScheduler;
